// extracted by mini-css-extract-plugin
module.exports = {"orange":"#e38826","darkCyan":"#006970","veryDarkCyan":"#004241","color-picker__item":"css-6c2e821","color-picker__button":"css-7cec9f6","active":"css-c676fed"};